<template>
  <div v-if="isReadyToDraw" class="column">
    <div class="status-button">
      <a
        class="button"
        @click="
          goToExternalLink(
            'https://www.odakyu.jp/cgi-bin/user/emg/emergency_bbs.pl'
          )
        "
      >
        <div v-if="railWayStatusMessage" class="row">
          {{ displayTime }} {{ railWayStatusMessage }}
        </div>
        <div v-else class="row">
          {{ displayTime }} 小田急線は平常どおり運転しております
        </div>
        <div class="row"><i class="fa fa-fw fa-angle-right"></i></div>
      </a>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import mfittService from "@/services/MFITT";
export default {
  name: "MFITTOperationInformation",
  setup() {
    const isReadyToDraw = ref(false);
    const displayTime = ref(null);
    const railWayStatusMessage = ref(null);

    onMounted(async () => {
      const railWayStatus = await mfittService.fetchRailWayStatus();
      console.log("運行情報: ", railWayStatus);
      displayTime.value = convertDisplayTime(
        railWayStatus.resultset[0].update_time
      );
      railWayStatusMessage.value = railWayStatus.resultset[0].message;
      isReadyToDraw.value = true;
    });

    const convertDisplayTime = (dateTime) => {
      const time = dateTime.split("T")[1];
      return time.substr(0, 5);
    };

    return {
      isReadyToDraw,
      displayTime,
      railWayStatusMessage,
    };
  },
};
</script>

<style lang="scss">
.column .status-button .button {
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 10px 14px 10px 20px;
  font-size: 13px;
  line-height: 16px;
  font-weight: bold;
  color: #000000;
  text-decoration: none;
  border: 1px solid #ffb206;
  overflow: hidden;
  border-top-left-radius: 17px;
  border-top-right-radius: 17px;
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
}
</style>
